import {forwardRef, Ref} from 'react';
import {
  Box,
  FormControl,
  InputBase,
  InputBaseProps,
  InputLabel,
  Slide,
  Stack,
  styled,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';
import {Pallete} from '../../../../theme/bluebird';

export const CardStyledInput = styled(InputBase)(({theme}) => ({
  backgroundColor: theme.palette.background.paper,
  lineHeight: '24px',
  borderRadius: '5px',
  minHeight: '56px',
  boxShadow: '0px 4px 16px 0px rgba(29, 41, 57, 0.1)',
  '& .MuiInputBase-input': {
    padding: 0,
    borderRadius: '5px',
    fontSize: '16px',
    lineHeight: '18px',
    fontWeight: 500,
    color: 'var(--dcm-gray)',
  },
}));

interface CardStyledInputProps extends InputBaseProps {
  errors?: string;
  label?: string;
  suffix?: string;
  shrinkLabel?: boolean;
}

const suffixSx: SxProps<Theme> = {
  color: 'var(--dcm-gray)',
  fontSize: '20px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: 'normal',
};

export const DailyCareInput = forwardRef(
  (
    {errors, suffix, label, shrinkLabel, ...rest}: CardStyledInputProps,
    ref: Ref<HTMLInputElement>
  ) => {
    const hasError = !!errors;

    return (
      <FormControl
        sx={{
          width: '100%',
        }}
      >
        <Stack width="100%" flexDirection="row" gap="16px" alignItems="center">
          <Box sx={{width: '100%'}}>
            <InputLabel
              variant="filled"
              color="primary"
              required={rest.required}
              shrink={shrinkLabel}
              sx={{
                color: 'var(--dcm-gray-light)',
                '&.Mui-focused': {
                  color: 'var(--dcm-gray-light)',
                },
              }}
            >
              {label || rest.placeholder}
            </InputLabel>
            <CardStyledInput
              ref={ref}
              {...rest}
              sx={{
                ...rest.sx,
                padding: '24px 12px 12px 12px',
                width: '100%',
              }}
              placeholder={undefined}
              // onloadwff error https://github.com/mui/material-ui/issues/14860
              inputProps={{...rest.inputProps, 'data-lpignore': true}}
            />
          </Box>
          {suffix && <Typography sx={suffixSx}>{suffix}</Typography>}
        </Stack>
        <Slide direction="left" in={hasError} mountOnEnter unmountOnExit>
          <span className="input-error" style={{color: Pallete.red.base}}>
            {errors}
          </span>
        </Slide>
      </FormControl>
    );
  }
);
